import { HEARTBEAT_STALE_MINUTES } from '@brimstone/shared';
import { EmptyState, Panel } from '../../components/ui';
import { useStatus } from '../../lib/queries';
import { formatAge, formatClock, minutesSince } from '../../lib/time';

/** Settings → Watcher (M2): what the last heartbeat said. */
export function WatcherStatusPanel() {
  const status = useStatus();
  const w = status.data?.watcher;

  if (!status.data) {
    return (
      <Panel title="Watcher" level="side">
        <EmptyState>{status.isError ? 'Couldn’t load the watcher status.' : 'Loading…'}</EmptyState>
      </Panel>
    );
  }
  if (!w?.lastHeartbeatAt) {
    return (
      <Panel title="Watcher" level="side" meta="NOT PAIRED">
        <EmptyState>
          No heartbeat yet. Run the watcher on your gaming PC, create a token here, copy it and
          choose “Pair” in the watcher’s tray menu.
        </EmptyState>
      </Panel>
    );
  }
  const stale = minutesSince(w.lastHeartbeatAt) > HEARTBEAT_STALE_MINUTES;
  return (
    <Panel title="Watcher" level="side" meta={stale ? undefined : 'ONLINE'}>
      {stale && (
        <p className="m-0 border-b border-line px-4 py-3 text-secondary text-danger">
          <span className="font-mono font-semibold">OFFLINE</span> · no heartbeat for{' '}
          {formatAge(w.lastHeartbeatAt).replace(' ago', '')}. Is the watcher running?
        </p>
      )}
      <dl className="m-0 grid grid-cols-[max-content_minmax(0,1fr)] gap-x-3.5 gap-y-1.5 px-4 py-3 text-compact">
        <dt className="text-muted">Version</dt>
        <dd className="m-0 font-mono">{w.watcherVersion ?? '—'}</dd>
        <dt className="text-muted">Game folder</dt>
        <dd className="m-0 truncate font-mono">{w.gameFolder ?? 'not chosen'}</dd>
        <dt className="text-muted">Heartbeat</dt>
        <dd className={`m-0 font-mono ${stale ? 'text-danger' : ''}`}>
          {formatClock(w.lastHeartbeatAt)} · {formatAge(w.lastHeartbeatAt)}
        </dd>
        <dt className="text-muted">Last upload</dt>
        <dd className="m-0 font-mono">
          {w.lastUploadAt
            ? `${formatClock(w.lastUploadAt)} · ${formatAge(w.lastUploadAt)}`
            : 'none yet'}
        </dd>
        <dt className="text-muted">Queue</dt>
        <dd className="m-0 font-mono">
          {w.queueLength === 0 ? 'empty' : `${w.queueLength} waiting`}
        </dd>
        <dt className="text-muted">Files stored</dt>
        <dd className="m-0 font-mono">{status.data.rawFiles}</dd>
      </dl>
    </Panel>
  );
}
